module.exports = __webpack_public_path__ + "files/654d0825420c05a5d44eb9548093dd18.png";